/*
 * @Author: wangbaihe
 * @Date: 2025-07-08 09:19:57
 * @LastEditors: wangbaihe
 * @LastEditTime: 2026-01-12 18:13:51
 * @FilePath: \common-mediax\src\apis\MediaCloudJournal\Manage.js
 * @Description: MediaCloudJournalManage
 */
import { createAPI } from '@common'

export default {
  // 新建和修改刊物（刊物管理
  postJournalSave: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0tzt0kpvsobm0tbwf', 'POST', config),
  // 查询单个期刊信息（刊物管理
  getJournalDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0tzt0kpvsobm0hfu', 'GET', config),
  // 删除刊物（刊物管理
  postJournalDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0tzt0kpvsobm0efmfuf', 'POST', config),
  // 新建和修改栏目（栏目管理
  postJournalColumnSave: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0tzt0kpvsobm0dpmvno0tbwf', 'POST', config),
  // 查询单个栏目信息（栏目管理
  getJournalColumnDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0tzt0kpvsobm0dpmvno0hfu', 'GET', config),
  // 删除栏目（栏目管理
  postJournalColumnDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0tzt0kpvsobm0dpmvno0efmfuf', 'GET', config),

  // 新建和修改某个刊物的刊期（刊期管理
  postJournalDateSave: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0tzt0kpvsobm0ebuf0tbwf', 'POST', config),
  // 批量创建某个刊物的刊期（刊期管理
  postJournalDateBatchSave: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0tzt0kpvsobm0ebuf0cbudiTbwf', 'POST', config),
  // 删除刊期（刊期管理
  postJournalDateDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0tzt0kpvsobm0ebuf0efmfuf', 'POST', config),

  // 获取全部期刊刊物和刊物信息
  getAllJournals: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0tzt0kpvsobm0bmm', 'GET', config),

  // 刊物排序
  putJournalSort: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0tzt0kpvsobm0tpsu', 'PUT', config),
  // 获取刊物栏目的子栏目
  getJournalColumnSubs: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0tzt0kpvsobm0dpmvno0tvct', 'GET', config),
  // 刊物子栏目排序
  putColumnSort: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0tzt0kpvsobm0dpmvno0tpsu', 'PUT', config)
}
